import * as React from "react";
export class ViewAllBtn extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-ev-list__view-all-btn__wrap", "data-uat": "div-ev-list-view-all-btn-wrap" },
            React.createElement("a", { className: "rj-ev-list__view-all-btn__link", href: this.props.linkUrl, onClick: (e) => this.props.onClick(e), "data-uat": "div-ev-list-view-all-btn-link" },
                React.createElement("span", { className: "rj-ev-list__view-all-btn__text", "data-uat": "span-ev-list-view-all-btn-text" }, this.props.text))));
    }
}
//# sourceMappingURL=ViewAllBtn.js.map